import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { GradientText } from './StyledText'

type QVBreakdownProps = {
  earned: string
  outstanding: string
  total: string
}

export const QVBreakdown = (props: QVBreakdownProps) => {
  const { earned, outstanding, total } = props
  const montserratFont = 'Montserrat, san serif'

  const gradient = 'linear-gradient(74deg, #34E3DF 16.27%, #02AEEE 86.38%)'

  const totals = [
    { label: 'Earned', amount: earned, isGradient: true },
    { label: 'Left', amount: outstanding, isGradient: false },
    { label: 'Total', amount: total, isGradient: false },
  ]

  const getTotalStyles = (hasGradient: boolean, amount: string) => {
    if (hasGradient) {
      return (
        <GradientText color={gradient} fontSize=".825rem">
          {amount} QVs
        </GradientText>
      )
    } else {
      return (
        <Text
          type="body"
          style={{
            fontSize: '.825rem',
            fontWeight: 500,
            fontFamily: montserratFont,
            color: '#505050',
          }}
          whiteSpace="nowrap"
        >
          {amount} QVs
        </Text>
      )
    }
  }

  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%">
      <Div
        outset={{ left: '85px' }}
        display="flex"
        width="100%"
        flexDirection="column"
      >
        {totals.map((total, index) => {
          return (
            <Flex
              key={index}
              justifyContent="space-between"
              alignContent="flex-start"
              alignItems="center"
              width="100%"
            >
              <Text
                type="body"
                style={{
                  fontSize: '.825rem',
                  fontWeight: 500,
                  fontFamily: montserratFont,
                  color: '#9A9A9A',
                  whiteSpace: 'nowrap',
                }}
              >
                {total.label}:
              </Text>
              {getTotalStyles(total.isGradient, total.amount)}
            </Flex>
          )
        })}
      </Div>
    </Flex>
  )
}
